import { render } from "./GoogleTwoFactor.vue?vue&type=template&id=69e8b398"
import script from "./GoogleTwoFactor.vue?vue&type=script&lang=js"
export * from "./GoogleTwoFactor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Saad/Documents/GitHub/link-portal/link/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__